import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

Vue.use(Vuex);

const vuexPersist = new VuexPersist(
	{
		key: 'co.elumin.sandbox',
		storage: sessionStorage
	}
);

export default new Vuex.Store(
	{
		state:
		{
			clientKey: undefined,
			userToken: undefined,
			clientConfig: undefined,
			profile: undefined,
			shouldShowTooltips: false,
			loadedAt: new Date()
		},
		getters:
		{
			getClientKey: state => state.clientKey,
			getUserToken: state => state.userToken,
			getClientConfig: state => state.clientConfig,
			getProfile: state => state.profile
		},
		mutations:
		{
			clientKey(state, v)
			{
				state.clientKey = v;
			},
			userToken(state, v)
			{
				state.userToken = v;
			},
			clientConfig(state, v)
			{
				state.clientConfig = v;
			},
			profile(state, v)
			{
				state.profile = v;
			},
			shouldShowTooltips(state, v)
			{
				state.shouldShowTooltips = v;
			},
			loadedAt(state, v)
			{
				state.loadedAt = v;
			}
		},
		plugins: [ vuexPersist.plugin ]
	}
);
